// TermsAndConditions.js
import React from "react";
import "./tearm&conditions.css";
import Header from "../../components/Navbar";
import Footer from "../../components/footer/footer";

function TermsAndConditions() {
  return (
    <>
      <Header />

      <div className="max-w-5xl mx-auto p-6 text-gray-800 leading-relaxed" style={{marginTop:"44px"}}>
        {/* Title */}
        <h1 className="text-2xl font-bold text-center mb-2">
          TERMS & CONDITIONS
        </h1>

        <p className="text-center text-gray-600 mb-6">
          Effective Date: February 9, 2026
        </p>

        <div className="h-[75vh] overflow-y-auto pr-4 space-y-5">

          {/* Intro */}
          <p>
            These Terms & Conditions (the “Agreement”) are a legal agreement between you and
            <b> Twoffers – A Product of 2022842 Ontario Inc</b> (“Twoffers,” “we,” “us,” or “our”).
          </p>

          <p>
            By accessing or using the website https://www.twoffers.com (the “Site”) and any related
            services, tools, or mobile applications (collectively, the “Platform”), including any
            affiliated websites or applications we operate (the “Affiliated Websites and Apps”),
            you agree to be bound by this Agreement.
          </p>

          {/* Important Notice */}
          <h2 className="text-xl font-semibold mt-6">IMPORTANT NOTICE</h2>

          <p>
            This Agreement includes a class action waiver, warranty disclaimers, limitations of liability,
            and your agreement to indemnify Twoffers. Section 16 explains your consent to receive communications
            (and how to revoke it).
          </p>

          <p>
            We may update this Agreement from time to time. Changes will be posted on the Site
            and/or notified by email where required. Continued use of the Platform constitutes
            acceptance of the updated Agreement.
          </p>

          <p>
            This Agreement applies to all properties, listings, or assets marketed through the Platform,
            whether via time-limited listings or offer-based formats.
          </p>

          {/* Platform Structure */}
          <h2 className="text-xl font-semibold mt-6">PLATFORM STRUCTURE & TRANSACTIONS</h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>Selected Offerors must execute a Purchase Agreement with the Seller.</li>
            <li>Twoffers is not a party to any Purchase Agreement.</li>
            <li>If conflicts arise, the Purchase Agreement controls for those parties.</li>
            <li>Licensed agents or auctioneers are also bound by this Agreement.</li>
          </ul>

          {/* Defined Terms */}
          <h2 className="text-xl font-semibold mt-6">DEFINED TERMS</h2>

          <ul className="list-disc pl-6 space-y-2">
            <li><b>Affiliated Websites and Apps</b> — websites or apps operated by Twoffers.</li>
            <li><b>Auction Marketing</b> — time-limited online offer process.</li>
            <li><b>Back-Up Offer</b> — secondary offer held at Seller’s discretion.</li>
            <li><b>Offer Deposit</b> — temporary authorization hold before submitting an Offer.</li>
            <li><b>Offeror</b> — person/entity submitting an Offer.</li>
            <li><b>Buyer</b> — party entering a Purchase Agreement.</li>
            <li><b>Buyer’s Premium</b> — additional fee charged to Buyers.</li>
            <li><b>Earnest Money Deposit</b> — good-faith escrow deposit.</li>
            <li><b>Listing Page</b> — property or asset information page.</li>
            <li><b>No-Time-Limit Marketing</b> — offer-based process without deadline.</li>
            <li><b>Selected Offer</b> — offer chosen by Seller (not guaranteed sale).</li>
            <li><b>Seller</b> — owner or authorized listing party.</li>
            <li><b>Technology/Platform Fee</b> — transaction-related service fee.</li>
          </ul>

          {/* Section 1 */}
          <h2 className="text-xl font-semibold mt-8">1) Services; Fees</h2>

          <p><b>(a) Limited License</b> – Limited, revocable license to use the Platform.</p>
          <p><b>(b) Proprietary Rights</b> – All intellectual property belongs to Twoffers.</p>
          <p><b>(c) Third-Party Content</b> – We are not responsible for accuracy of seller/user content.</p>
          <p><b>(d) Use & Storage</b> – We may impose reasonable limits on usage and data retention.</p>

          <p className="mt-3"><b>(e) Offeror Requirements & Fees</b></p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Account required to submit Offers.</li>
            <li>Offer Deposit & funds verification may apply.</li>
            <li>Earnest Money Deposit may be required after selection.</li>
            <li>Technology/Platform Fee may apply.</li>
            <li>Buyer’s Premium may apply to auction purchases.</li>
          </ul>

          {/* Section 2 */}
          <h2 className="text-xl font-semibold mt-8">2) Eligibility & Your Responsibilities</h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>You must be legally capable of forming contracts.</li>
            <li>Provide accurate registration information.</li>
            <li>Safeguard your login credentials.</li>
            <li>No fraud, scams, reverse engineering, or system interference.</li>
            <li>Accounts may be suspended or terminated at our discretion.</li>
          </ul>

          {/* Section 3 */}
          <h2 className="text-xl font-semibold mt-8">3) Twoffers Is a Technology Platform</h2>

          <p>
            Twoffers is not an auctioneer, broker, or fiduciary. We only provide technology services.
            Disputes are solely between Buyers and Sellers.
          </p>

          {/* Section 4 */}
          <h2 className="text-xl font-semibold mt-8">4) Offer & Buying Process</h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>Submitting an Offer shows serious intent but is not binding.</li>
            <li>Failure to complete may result in deposit forfeiture.</li>
            <li>Listings may auto-extend.</li>
            <li>Sellers may accept/reject any Offer.</li>
            <li>Proof of funds may be required.</li>
          </ul>

          {/* Section 5 */}
          <h2 className="text-xl font-semibold mt-8">5) Listing Condition; No Warranties</h2>

          <p>
            Listings and Platform are provided “AS IS” and “AS AVAILABLE.”
            All warranties are disclaimed to the maximum extent permitted by law.
          </p>

          {/* Section 6 */}
          <h2 className="text-xl font-semibold mt-8">6) Privacy</h2>
          <p>See our Privacy Policy at: https://twoffers.com/privacypolicy</p>

          {/* Section 7 */}
          <h2 className="text-xl font-semibold mt-8">7) Indemnity</h2>
          <p>You agree to indemnify and hold Twoffers harmless from claims arising from your use of the Platform.</p>

          {/* Section 8 */}
          <h2 className="text-xl font-semibold mt-8">8) Limitation of Liability</h2>
          <p>Total liability is limited to $100 USD. No indirect or consequential damages.</p>

          {/* Section 9 */}
          <h2 className="text-xl font-semibold mt-8">9) Legal Compliance</h2>
          <p>You agree to comply with all applicable laws and regulations.</p>

          {/* Section 10 */}
          <h2 className="text-xl font-semibold mt-6">10) No Agency</h2>
          <p>No agency, partnership, or joint venture relationship is created.</p>

          {/* Section 11 */}
          <h2 className="text-xl font-semibold mt-6">11) General</h2>
          <p>This Agreement constitutes the entire agreement between you and Twoffers.</p>

          {/* Section 12 */}
          <h2 className="text-xl font-semibold mt-6">12) Additional Terms for Licensed Agents</h2>
          <p>Licensed agents remain responsible for regulatory compliance.</p>

          {/* Section 13 */}
          <h2 className="text-xl font-semibold mt-6">13) Jurisdiction-Specific Auction Terms</h2>
          <p>Additional local rules may apply depending on location and asset type.</p>

          {/* Section 14 */}
          <h2 className="text-xl font-semibold mt-6">14) Loan / Note Sales</h2>
          <p>Special terms may apply to loan or note transactions.</p>

          {/* Section 15 */}
          <h2 className="text-xl font-semibold mt-6">15) Commercial Listings — Confidentiality</h2>
          <p>Certain commercial listings may require confidentiality obligations.</p>

          {/* Section 16 */}
          <h2 className="text-xl font-semibold mt-6">16) Communication Consent</h2>
          <p>By using the Platform, you consent to receive account and transaction communications.</p>

          <h3 className="text-lg font-semibold mt-4">16.1 SMS Messages</h3>
          <p>You may opt out of SMS at any time using instructions in the message.</p>

          {/* Section 17 */}
          <h2 className="text-xl font-semibold mt-8">17) Contact Us</h2>

          <p>
            Twoffers – A Product of 2022842 Ontario Inc <br />
            📧 support@twoffers.com <br />
            📞 +1 (416) 821-7180
          </p>

        </div>
      </div>

      <Footer />
    </>
  );
}

export default TermsAndConditions;